import classNames from 'classnames';
import React from 'react';
import styles from '../styles/formError.module.scss';

export default function FormError(props: {
  errors: Record<any, any>;
  field: string;
  className?: string;
}) {
  return props.errors[props.field] ? (
    <span className={classNames(styles.formError, props.className)}>
      {props.errors[props.field].message}
    </span>
  ) : null;
}
